import type { DeltaNeutralBotDto } from "@cede/types";
import type { BotTypeConfig } from "./bot-config-types";
import { SHARED_STATUS_STYLES } from "./bot-shared-styles";
import Decimal from "decimal.js";
import { Loader2, Play } from "lucide-react";

export const DN_BOT_CONFIG: BotTypeConfig<DeltaNeutralBotDto> = {
  type: "delta-neutral",
  fieldAccessors: {
    getId: (bot) => bot.id,
    getStatus: (bot) => bot.status,
    getCreatedAt: (bot) => bot.createdAt,
    getPnl: (bot) => new Decimal(bot.netPnlUsdc).toNumber(),
    getVolumeMetric: (bot) => new Decimal(bot.totalOpenInterestUsdc).toNumber(),
  },
  statusPriority: {
    RUNNING: 0,
    OPENING: 1,
    PENDING: 2,
    CLOSING: 3,
    ERROR: 4,
    STOPPED_MAX_LOSS: 5,
    STOPPED: 6,
  },
  statusStyles: {
    PENDING: SHARED_STATUS_STYLES.PENDING,
    OPENING: {
      icon: Loader2,
      label: "Opening",
      color: "text-amber-400",
      bg: "bg-amber-400/10",
      border: "border-amber-400/20",
      spin: true,
    },
    RUNNING: {
      icon: Play,
      label: "Running",
      color: "text-emerald-400",
      bg: "bg-emerald-400/10",
      border: "border-emerald-400/20",
    },
    CLOSING: {
      icon: Loader2,
      label: "Closing",
      color: "text-cede-text-tertiary",
      bg: "bg-cede-text-tertiary/10",
      border: "border-cede-text-tertiary/20",
      spin: true,
    },
    STOPPED: SHARED_STATUS_STYLES.STOPPED,
    STOPPED_MAX_LOSS: SHARED_STATUS_STYLES.STOPPED_MAX_LOSS,
    ERROR: SHARED_STATUS_STYLES.ERROR,
  },
  filterStatuses: ["RUNNING", "OPENING", "PENDING", "CLOSING", "STOPPED", "STOPPED_MAX_LOSS", "ERROR"],
  sortOptions: [
    { key: "date", label: "Date", defaultDir: "desc" },
    { key: "status", label: "Status", defaultDir: "asc" },
    { key: "volume", label: "OI", defaultDir: "desc" },
    { key: "pnl", label: "PnL", defaultDir: "desc" },
  ],
  supportsDuplication: true,
};
